// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagePage__root___2PMI2","content":"MessagePage__content___t3ux1","back":"MessagePage__back___3PMnM"};